module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (47).35d69f40.jpg";